import { validateEnv } from "./schema"

export const env = validateEnv(import.meta.env)
